<template>

    <!-- search-top -- >
    <div class="search-top">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <div class="search-box">
            <div class="todayselect">
              <select class="form-control" aria-label="agents">
                <option>Select agents</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-8">
          <div class="export-right">
            <div class="export">
              <a href="#"> My Reports</a>
            </div>
            <div class="todayselect">
              <div class="reportrange">
                This Month <i class="fa fa-angle-down" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <! -- search-top -->

    <!-- all-task -->
    <div class="all-task">
      <div class="row">
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Appointments.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ todayAppointments }}</h5>
                <p>Today’s Appointments </p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Tasks.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ newMessages }}</h5>
                <p>New Patients</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Alarts.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ unreadMessages }}</h5>
                <p>Today's Alerts</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Untouched.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ pendingFollowUp }}</h5>
                <p>Payment Due</p>
              </div>
            </a>
          </div>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Appointments.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ todayAppointments }}</h5>
                <p>Total Appointments </p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Tasks.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ newMessages }}</h5>
                <p>All Patients</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Alarts.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ unreadMessages }}</h5>
                <p>Today's Alerts</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Untouched.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ pendingFollowUp }}</h5>
                <p>Payment Made</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- all-task -->


    <!-- activity-area -->
    <div class="activity-area">
      <div class="row">
        <!-- left-side -->
        <div class="col-md-7 col-lg-8">
          <div class="row">
            <div class="col-12">
              <!-- activitybox -->
              <div class="activitybox">
                <div class="box-title">
                  <h3>Patient Tracker</h3>
                </div>
                <div class="chat-box">
                  <div id="Leads"></div>
<apexchart 
type="area" 
height="280" 
:options="leadsOptions" 
:series="leadsSeries"
></apexchart>
                </div>
              </div>
              <!-- activitybox -->
            </div>
          </div>
        </div>
        <!-- left-side -->
        <!-- right-side -->
        <div class="col-md-5 col-lg-4">
          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Appointments</h3>
            </div>
            <div class="chat-box">
              <div id="Serviced"></div>
<apexchart 
type="donut" 
height="220" 
:options="donutOptions" 
:series="donutSeries"
></apexchart>
            </div>

          </div>
          <!-- activitybox -->
          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Sales Funnel</h3>
            </div>
            <div class="sale-funnel">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="funnel-img"><img class="img-fluid" src="@/assets/img/Funnel.svg" alt="image title"></div>
                </div>
                <div class="col-md-6">
                  <div class="funnel-list">
                    <ul>
                      <li><a href="#">Status <h5>Leads</h5></a></li>
                      <li><a href="#"><span class="funnel-1"></span> Messages Sent <h5>{{ messagesSent }}</h5></a></li>
                      <li><a href="#"><span class="funnel-2"></span> Replies Received <h5>{{ repliesReceived }}</h5></a></li>
                      <li><a href="#"><span class="funnel-3"></span> Appointment Set <h5>{{ appointmentsSet }}</h5></a></li>
                      <li><a href="#"><span class="funnel-4"></span> Apps Shown <h5>{{ appsShown }}</h5></a></li>
                      <li><a href="#"><span class="funnel-5"></span> Opted Out <h5>{{ optedOut }}</h5></a></li>
                    </ul>
                  </div>
                </div>
                <div class="sale-table">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>100% </th>
                          <th>75% </th>
                          <th>43% </th>
                          <th>10% </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Contacted </td>
                          <td>Appointment </td>
                          <td>Apps Shown </td>
                          <td>Delivered </td>
                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!-- activitybox -->
        </div>
        <!-- right-side -->
      </div>
    </div>
    <!-- activity-area -->
</template>
<script>
import $ from "jquery";
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  setup() {
    const Router = useRouter();
    if(localStorage.getItem("user_id") != 177){
      Router.push("/inbox/all");
    }

    // Open Modal
    const openModal = () => {
      $("#featureNotAvailable").modal("show");
    };

    // Close Modal
    const closeModal = () => {
      $("#featureNotAvailable").modal("hide");
    };
    // let barChartSeries = ref([]);
    let todayAppointments = ref(0);
    let newMessages = ref(0);
    let unreadMessages = ref(0);
    let pendingFollowUp = ref(0);
    let newContacts = ref(0);
    let activeContacts = ref(0);
    let coldContacts = ref(0);
    let appointmentScheduled = ref(0);
    let noResponse = ref(0);
    let messagesSent = ref(0);
    let repliesReceived = ref(0);
    let appointmentsSet = ref(0);
    let appsShown = ref(0);
    let optedOut = ref(0);

    let activeAppointments = ref(0);
    let inboundLeads = ref(0);
    let totalConversation = ref(0);
    let averageResponseTime = ref('0m');

/* CHARTS */
// ===========================================
    // 1. LEADS CHART CONFIG
    // ===========================================
    const leadsSeries = ref([
      { name: 'Leads', data: [51, 40, 18, 51, 41, 109, 100] },
      { name: 'Serviced', data: [35, 32, 42, 24, 34, 52, 43] }
    ]);
    
    const leadsOptions = ref({
      colors: ['#F7AE33', '#5B93FF'],
      chart: { type: 'area', toolbar: { show: false } }, // Toolbar false looks cleaner
      dataLabels: { enabled: false },
      stroke: { width: 2, curve: 'smooth' },
      xaxis: {
        // Safe fix: Added categories to prevent date parsing crash
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      },
      tooltip: {
         // simplified tooltip
      },
      legend: { position: 'top', horizontalAlign: 'right', offsetX: -10 }
    });

    // ===========================================
    // 2. ACTIVITIES CHART CONFIG
    // ===========================================
    const activitySeries = ref([
      { name: 'Out', data: [44, 55, 57] },
      { name: 'In', data: [76, 85, 101] }
    ]);

    const activityOptions = ref({
      colors: ['#5B93FF', '#83AAF5'],
      chart: { type: 'bar', toolbar: { show: false } },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 4, // 'endingShape' is deprecated, use borderRadius
        },
      },
      dataLabels: { enabled: false },
      stroke: { show: true, width: 2, colors: ['transparent'] },
      xaxis: {
        categories: ['Call', 'Email', 'Text'],
      },
      fill: { opacity: 1 },
      legend: { position: 'top', horizontalAlign: 'right', offsetX: -10 }
    });

    // ===========================================
    // 3. SOURCES CHART CONFIG
    // ===========================================
    const sourcesSeries = ref([
      { data: [21, 22, 10] }
    ]);

    const sourcesOptions = ref({
      chart: { type: 'bar', toolbar: { show: false } },
      colors: ['#5B93FF', '#14B2D4', '#F7AE33'],
      plotOptions: {
        bar: {
          columnWidth: '20%',
          distributed: true,
          borderRadius: 6,
        }
      },
      dataLabels: { enabled: false },
      legend: { show: false },
      xaxis: {
        categories: ['Walk In', 'Phone', 'Internet']
      }
    });

    // ===========================================
    // 4. DONUT CHART CONFIG
    // ===========================================
    // Note: Donut series is a simple array, not an object array
    const donutSeries = ref([44, 55, 34]);

    const donutOptions = ref({
      chart: { type: 'donut' },
      colors: ['#5B93FF', '#14B2D4', '#FF8F6B'],
      dataLabels: { enabled: false },
      labels: ['New', ' Used', 'Purchase'],
      legend: { show: true, position: 'bottom', horizontalAlign: 'center' }
    });

    // ===========================================
    // 5. APPOINTMENTS CHART CONFIG
    // ===========================================
    const appointmentSeries = ref([
      { data: [32, 52, 58, 64, 12] }
    ]);

    const appointmentOptions = ref({
      chart: { type: 'bar', toolbar: { show: false } },
      colors: ['#14B2D4', '#5B93FF', '#19BE93', '#F7AE33', '#EA5757'],
      plotOptions: {
        bar: {
          barHeight: '20%',
          horizontal: true,
          distributed: true,
          borderRadius: 4,
          dataLabels: { position: 'top' }
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 0,
        offsetY: -20, // Adjusted to sit on top of thin bars
        style: { fontSize: '12px', colors: ['#000'] }
      },
      xaxis: {
        categories: ['Created', 'Scheduled', 'Confirmed', 'Show', 'No Show '],
      },
      legend: { show: false }
    });
/* CHARTS */
    const getDashboardData = async () => {
      const getFormData = new FormData();
      getFormData.append('dealer_id', localStorage.getItem('dealer_id'));
      getFormData.append('location_id', localStorage.getItem('location_id'));
      await axios
        .post(
          axios.defaults.baseUrl + "dashboard",
          getFormData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem('auth_token'),
            },
          }
        )
        .then((response) => {
          todayAppointments.value = response.data.data.todays_appointments;
          newMessages.value = response.data.data.new_messages;
          unreadMessages.value = response.data.data.unread_messages;
          pendingFollowUp.value = response.data.data.pending_follow_up;
          newContacts.value = response.data.data.new_contacts;
          activeContacts.value = response.data.data.active_contacts;
          coldContacts.value = response.data.data.cold_contacts;
          appointmentScheduled.value = response.data.data.appointment_scheduled;
          noResponse.value = response.data.data.no_response;
          messagesSent.value = response.data.data.messages_sent;
          repliesReceived.value = response.data.data.replies_received;
          appointmentsSet.value = response.data.data.appointments_set;
          appsShown.value = response.data.data.apps_shown;
          optedOut.value = response.data.data.opted_out;

          activeAppointments.value = response.data.data.active_appointments;
          inboundLeads.value = response.data.data.inbound_leads;
          totalConversation.value = response.data.data.total_conversations;
          averageResponseTime.value = response.data.data.average_response_time;
          // datatableInit();
        })
        .catch((error) => {
          window.showHideMainLoader(false);
          console.log(error);
          // showToast(error.response.data.status, error.response.data.message);
          return false;
        });
    }

    onMounted(() => {
      // console.log(localStorage.getItem('dealer_id'));
      // console.log(localStorage.getItem('location_id'));
      window.showHideMainLoader(false);
      getDashboardData();
      $(document).on('click','.menuwidth',function(e){
      console.log(e.target);
alert();
    });
    });

    return {
      openModal,
      closeModal,
      getDashboardData,
      todayAppointments,
      newMessages,
      unreadMessages,
      pendingFollowUp,
      newContacts,
      activeContacts,
      coldContacts,
      appointmentScheduled,
      noResponse,
      messagesSent,
      repliesReceived,
      appointmentsSet,
      appsShown,
      optedOut,
      activeAppointments,
      inboundLeads,
      totalConversation,
      averageResponseTime,

      // Return Leads
      leadsSeries,
      leadsOptions,
      // Return Activities
      activitySeries,
      activityOptions,
      // Return Sources
      sourcesSeries,
      sourcesOptions,
      // Return Donut
      donutSeries,
      donutOptions,
      // Return Appointments
      appointmentSeries,
      appointmentOptions
    };
  },
};
</script>
<style>
#printLead {
  display: none;
}

@media print {
  #printLead {
    display: block;
  }

  .main-area {
    display: none;
  }

  #leadDetailsContainer {
    display: block;
  }

  .mytable .table td:first-child {
    font-weight: 500;
  }

  .mytable .table td,
  .mytable .table th {
    padding: 8px 0;
    vertical-align: middle;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #e6e7e8;
    font-size: 14px;
    line-height: 1.5;
    color: #63729a;
  }

  .mytable .table td,
  .mytable .table th {
    padding: 8px 0;
    vertical-align: middle;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #e6e7e8;
    font-size: 14px;
    line-height: 1.5;
    color: #63729a;
  }

  span.dot {
    display: inline-block;
    height: 4px;
    width: 4px;
    background: #63729a;
    border-radius: 50%;
    margin-bottom: 1px;
    margin-right: 5px;
  }
}
</style>